export const EN_QUESTIONNAIRE_STRINGS = {
  QUESTIONNAIRE: '{count, plural, one {Questionnaire} other {Questionnaires}}',
  QUESTIONNAIRE_ENTITY_NAME: 'Questionnaire',
  QUESTIONNAIRE_METADATA_LABEL: 'Questionnaire',
  QUESTIONNAIRE_METADATA_TITLE_LABEL: 'Title',
  QUESTIONNAIRE_METADATA_TITLE_HINT: 'Title of the Questionnaire',
  QUESTIONNAIRE_METADATA_QUESTIONNAIRE_ID_LABEL: 'ID',
  QUESTIONNAIRE_METADATA_QUESTIONNAIRE_DESCRIPTION_LABEL: 'Description',
  QUESTIONNAIRE_METADATA_QUESTIONNAIRE_DESCRIPTION_HINT:
    'Questionnaire details/context',
  QUESTIONS_LABEL: 'Questions',
  QUESTION_LABEL_ADD: 'Add Question',
  QUESTION_ITEM_LABEL: 'Question',
  QUESTION_TEXT_LABEL: 'Text',
  QUESTION_TEXT_HINT: 'Question text',
  LINK_ID_LABEL: 'Link ID',
  QUESTIONNAIRE_MAIN_BANNER_TITLE: 'Editing a published questionnaire?',
  QUESTIONNAIRE_MAIN_BANNER_DESCRIPTION:
    'Remember to go to the activity and <b>trigger a sync</b> to pull in the latest updates after republishing',
  QUESTIONNAIRE_GENERATED_LINK_ID_BANNER_TITLE: 'Warning',
  QUESTIONNAIRE_GENERATED_LINK_ID_BANNER_DESCRIPTION:
    'Manually changing the generated Link ID can cause broken references. Use with caution.',
  QUESTION_CODE_LABEL: 'Question Code',
  QUESTION_CODE_HINT:
    'These are standardized identifiers used to uniquely identify canonical questions and answers. They serve to categorize the questions and answers. A question needs at least one code, but can have multiple. <a>{href}|Know more.</a> ',
  QUESTION_BINDING_LABEL: 'Question Binding',
  QUESTION_BINDING_HINT:
    'Select Normative if the wording follows a standardized health survey. Select Preferred if the wording has been adapted or modified. If you select Preferred, you will be able to change the display text of the question at Activity level.',
  QUESTION_BINDING_NORMATIVE: 'normative',
  QUESTION_BINDING_PREFERRED: 'preferred',
  QUESTION_ANSWER_TYPE_LABEL: 'Answer Type',
  QUESTION_ANSWER_TYPE_HINT:
    'Displays the format of the expected answer (e.g., multiple choice, numeric value, free text).',
  QUESTION_ANSWER_TYPE_QUANTITY: 'quantity',
  QUESTION_ANSWER_TYPE_CHOICE: 'choice',
  QUESTION_ANSWER_TYPE_TEXT: 'text',
  QUESTION_ANSWER_TYPE_DATE_WITH_OPTION: 'date with option',
  QUESTION_ANSWER_TYPE_DATE: 'date',
  QUESTION_ANSWER_TYPE_TIME: 'time',
  QUESTION_UNITS_LABEL: 'Unit',
  QUESTION_UNITS_HINT:
    'Choose the unit for measurable responses (e.g., kg, cm, hours)',
  QUESTION_ALLOW_MULTIPLE_LABEL: 'Allow Multiple',
  QUESTION_ALLOW_MULTIPLE_HINT:
    'Indicates whether the question allows multiple responses. You will configure the choices in the next step.',
  ANSWER_OPTION_LABEL_ADD: 'Add Answer Option',
  QUESTION_ANSWER_OPTIONS_LABEL: 'Answer Options',
  QUESTION_ANSWER_OPTION_LABEL: 'Answer Option',
  QUESTION_ANSWER_OPTION_TYPE_LABEL: 'Type',
  QUESTION_ANSWER_OPTION_TYPE_HINT:
    'Choose the answer type to indicate how users should respond to this question. <a>{href}|Know more.</a> ',
  QUESTION_ANSWER_OPTION_TYPE_DATE: 'date',
  QUESTION_ANSWER_OPTION_TYPE_CODING: 'coding',
  QUESTION_ANSWER_OPTION_TYPE_STRING: 'string',
  QUESTION_ANSWER_OPTION_TYPE_DECIMAL: 'decimal',
  QUESTION_ANSWER_OPTION_TYPE_INTEGER: 'integer',
  QUESTION_ANSWER_OPTION_TYPE_TIME: 'time',
  QUESTION_ANSWER_OPTION_DISPLAY_TEXT_LABEL: 'Display Text',
  QUESTION_ANSWER_OPTION_CODE_LABEL: 'Choose code',
  QUESTION_ANSWER_OPTION_CODE_HINT:
    'Choose a code. These are standardized identifiers used to uniquely identify canonical questions and answers. They serve to categorize the questions and answers. To configure a new Code, click here. <a>{href}|Know more.</a>',
  QUESTION_REQUIRED_LABEL: 'Required',
  QUESTION_REQUIRED_HINT:
    'Check this option if an answer for this question is <strong>mandatory for the system to consider the entire questionnaire response complete and generate results</strong> (e.g., Health Risks / Focus Areas). If set to true, the author must ensure all users are presented with this question, irrespective of branching logic. <strong>A missing answer will result in an incomplete response.</strong>',
  QUESTION_QUESTION_CODES_ITEM: 'Question Code',
  QUESTION_QUESTION_CODES_ADD_LABEL: 'Add Question Code',
  QUESTION_QUESTION_UNITS_ADD_LABEL: 'Add Unit',
  QUESTION_ALLOW_DECIMAL_LABEL: 'Allow Decimal',
  QUESTION_ALLOW_DECIMAL_HINT:
    'When this field is selected the question maps to a Decimal Input component, and when not selected it maps to an Integer Input component in the Activity',
  QUESTION_QUESTION_UNITS_ITEM: 'Unit',
  QUESTION_ANSWER_OPTIONS_ITEM: 'Answer Options Code',
  QUESTIONNAIRE_METADATA_QUESTIONNAIRE_CONTEXT_ONBOARDING: 'Onboarding',
  QUESTIONNAIRE_METADATA_QUESTIONNAIRE_CONTEXT_CONSENT: 'Consent',
  QUESTIONNAIRE_METADATA_QUESTIONNAIRE_CONTEXT_CAMPAIGN_ACTIVITY:
    'Campaign Activity',
  QUESTIONNAIRE_METADATA_QUESTIONNAIRE_CONTEXT_HEALTH_ASSESSMENT:
    'Health Assessment',
  QUESTIONNAIRE_METADATA_QUESTIONNAIRE_CONTEXT_SOCIAL_DETERMINANTS_OF_HEALTH:
    'Social Determinants of Health',
  QUESTIONNAIRE_METADATA_QUESTIONNAIRE_CONTEXT_LABEL: 'Intended Use',
  QUESTIONNAIRE_METADATA_QUESTIONNAIRE_CONTEXT_HINT:
    'Intended use or target context of this questionnaire.',
  LINK_ID_PREFIX_SPECIFIER_LABEL: 'Link ID Prefix Specifier',
  QUESTION_ANSWER_OPTION_VALUE_DATE_LABEL: 'Value',
  QUESTION_ANSWER_OPTION_VALUE_DATE_HINT:
    'Enter the date that will appear as the answer option',
  QUESTION_ANSWER_OPTION_VALUE_DECIMAL_LABEL: 'Value',
  QUESTION_ANSWER_OPTION_VALUE_DECIMAL_HINT:
    'Enter a decimal number that will serve as the answer option',
  QUESTION_ANSWER_OPTION_VALUE_INTEGER_LABEL: 'Value',
  QUESTION_ANSWER_OPTION_VALUE_INTEGER_HINT:
    'Enter a whole number that will serve as the answer option',
  QUESTION_ANSWER_OPTION_VALUE_STRING_LABEL: 'Value',
  QUESTION_ANSWER_OPTION_VALUE_STRING_HINT:
    'Enter the text that will appear as the answer option',
  QUESTION_ANSWER_OPTION_VALUE_TIME_LABEL: 'Value',
  QUESTION_ANSWER_OPTION_VALUE_TIME_HINT:
    'Enter the time that will appear as the answer option',
  QUESTION_ANSWER_OPTION_VALUE_CODING_LABEL: 'Value',
  QUESTION_ANSWER_OPTION_VALUE_CODING_HINT:
    'You can add an internal value or code to an answer if you want. For example, if the answer is "Severely depressed,” you might use the code 5 behind the scenes.',
  GENERATE_TOOLBOX_ACTIVITY: 'Generate Toolbox Activity',
  GENERATING_TOOLBOX_ACTIVITY: 'Generating Toolbox Activity',
  TOOLBOX_ACTIVITY_GENERATED:
    'Toolbox Activity Created. View it on the Activity Entity listing page.',
  CONFIRM_GENERATE_TOOLBOX_ACTIVITY:
    'Are you sure you want to generate a Toolbox Activity for this Questionnaire?',
  QUESTION_DATE_OPTIONS_ADD_LABEL: 'Add Date Option',
  QUESTION_DATE_OPTIONS_LABEL: 'Date Options',
  QUESTION_DATE_OPTION_LABEL: 'Date Option',
  QUESTION_DATE_OPTION_DISPLAY_TEXT_LABEL: 'Display Text',
  QUESTION_DATE_OPTION_VALUE_LABEL:
    'Enter a number to adjust the current date by the selected unit (e.g., -3 months = 3 months ago)',
  QUESTION_DATE_OPTION_CODE_LABEL:
    'Choose Code - These are standardized identifiers used to uniquely identify canonical questions and answers. They serve to categorize the questions and answers',
  QUESTION_DATE_OPTION_UNIT_LABEL:
    'Choose Unit - choose the unit for measurable responses (e.g., year, month, week, and day)',
  QUESTION_LINK_ID_HINT:
    'Link ID is a unique identifier automatically generated for each question. It is required  to connect each response to its corresponding question.',
  QUESTION_TEXT_TYPE_FORMAT_HINT: 'Select the format of the question text.',
  QUESTION_TEXT_TYPE_FORMAT_LABEL: 'Text Format',
  QUESTION_TEXT_TYPE_FORMAT_PLAIN: 'plain text',
  QUESTION_TEXT_TYPE_FORMAT_EMAIL: 'email',
  QUESTION_TEXT_TYPE_FORMAT_PHONE_NUMBER: 'phone number',
};
